import {
  FETCHED_MY_UNMATCHED_ORDERS,
} from '../../types';

import callBC from '../../helpers/bc'
import {getBlake} from '../../passport/get';
import {fromUnit,pairs} from '../../../config';
import {deletePending,triggerEvents} from '../../ui/marketplace';
import {lowestDenom} from '../../../config';
import { getWallet } from '../../helpers/wallet';

export async function getUnmatchedOrders(dispatch,state){
  try {
    // console.log("start")
    let dat = Date.now()
    let data = await callBC(state.settings.settings,'getUnmatchedOrders',[state.passport.wallet.emb.address])
    let orders = data.result && data.result.ordersList ? cleanUpOrders(data.result.ordersList,state.socket.bcHeight) : [];

    dispatch({
      type:FETCHED_MY_UNMATCHED_ORDERS,
      payload: orders
    });

    deletePending(orders,state,dispatch)
    // console.log({finishedCall:(Date.now() - dat)/1000})
    return Promise.resolve(true)
  }
  catch(err){
    console.log({err})
  }
}

let cleanUpOrders = (orders,bcHeight) => {
  let txs = {}
  orders = orders.filter(o=>{
    if(txs[o.txHash]) return false
    else {
      txs[o.txHash] = true
      return true
    }
  })

  return orders.map(o => {
    o.receivesUnit = fromUnit(o.receivesToChain,o.receivesUnit)
    o.sendsUnit = fromUnit(o.sendsFromChain,o.sendsUnit)
    o.depositLeft = `in ${o.tradeHeight + o.deposit - bcHeight} Blocks`;
    o.settleLeft = `in ${o.tradeHeight + o.settlement - bcHeight} Blocks`;

    let demand = pairs['bid/ask'].reduce((total,{denomination,asset})=>{
      return total && (asset == o.sendsFromChain.toLowerCase() && denomination == o.receivesToChain.toLowerCase())
    },false)

    if(demand){
      o.price = o.receivesUnit / o.sendsUnit;
      o.amount = o.sendsUnit;
    } else {
      o.price = o.sendsUnit / o.receivesUnit;
      o.amount = o.receivesUnit;
    }
    return o;
  });
}
